import Link from 'next/link'
import React, { ReactNode } from 'react'

import { cn } from '../../../shadcn/utils'

type ICarouselCard = {
  image: ReactNode
  item: ReactNode
  classNames?: {
    container?: string
    subContainer?: string
    image?: string
    item?: string
  }
  link?: {
    title: string
    href: string
    dataGtm: string
  }
}

export const CarouselCardWrapper = ({
  image,
  item,
  classNames,
  link,
}: ICarouselCard) => {
  const imageClassname = cn(
    'sm:h-[60vw] relative h-[14vw] max-h-56 max-[1700px]:h-[17vw] max-[1370px]:h-[20vw] max-[1070px]:h-[30vw] max-[750px]:h-[60vw]',
    classNames?.image,
  )
  const wrapperClassname = cn(
    'group block cursor-pointer px-2 focus:outline-none',
    classNames?.container,
  )
  const subWrapperClassname = cn(
    'relative flex cursor-pointer flex-col overflow-hidden rounded-[20px] rounded-t-[20px] border border-border focus:outline-none',
    classNames?.subContainer,
  )
  const itemClassname = cn('p-3', classNames?.item)

  const cardContent = (
    <article className={subWrapperClassname}>
      <div className={imageClassname}>{image}</div>
      <div className={itemClassname}>{item}</div>
    </article>
  )

  if (link) {
    return (
      <Link
        className={wrapperClassname}
        aria-label={link.title}
        data-gtm={link.dataGtm}
        href={link.href}
      >
        {cardContent}
      </Link>
    )
  }

  return <div className={wrapperClassname}>{cardContent}</div>
}
